export default __webpack_public_path__ + "media/images/apple_logo_black-3973bfb1.svg";